import React, { useContext, useEffect } from "react";
import hubSpotLogo from "../../../../assets/images/hubspot/hubspotlogo-web-color.svg";
import { OwAccordion } from "../../../shared/OwAccordion/OwAccordion";
import OwButton from "../../../shared/OwButton/OwButton";
import IErrorDTO from "../../../../models/DTO/IErrorDTO";
import EndpointsEnum from "../../../../models/EndpointsEnum";
import IHubspotStartOAuthDTO from "../../../../models/DTO/IHubspotStartOAuthDTO";
import UserContext from "../../../../contexts/UserContext";
import SupplierContext from "../../../../contexts/SupplierContext";
import OwBadge from "../../../shared/OwBadge/OwBadge";
import IHubspotDisconnectDTO from "../../../../models/DTO/IHubspotDisconnectDTO";
import INotification from "../../../../models/INotification";
import NotificationLevelEnum from "../../../../models/NotificationLevelEnum";
import NotificationPositionEnum from "../../../../models/NotificationPositionEnum";
import ILoadUserDTO from "../../../../models/DTO/ILoadUserDTO";
import { Socket } from "socket.io-client";

type Props = {
    setActivityIndicator: (activityIndicator: boolean) => void;
    socket: Socket;
    notifyFn: (data: IErrorDTO | null, _notification?: any, isFormatted?: boolean) => void;
};

export const HubspotConnect: React.FC<Props> = (props) => {
    const userModel = useContext(UserContext);
    const supplierModel = useContext(SupplierContext);

    useEffect(() => {
        props.socket.on(EndpointsEnum.HubspotOnStartOauth, onStartOauth);
        props.socket.on(EndpointsEnum.HubspotOnDisconnect, onDisconnect);

        return () => {
            props.socket.removeListener(EndpointsEnum.HubspotOnStartOauth, onStartOauth);
            props.socket.removeListener(EndpointsEnum.HubspotOnDisconnect, onDisconnect);
        };
    }, []);

    const startOauth = () => {
        const payload: IHubspotStartOAuthDTO = {
            userGuid: userModel.guid,
            userToken: userModel.token,
            supplierGuid: supplierModel.guid,
        };

        props.socket.emit(EndpointsEnum.HubspotStartOauth, payload);
    };

    const onStartOauth = (data: string) => {
        // @ts-expect-error
        window.location = data;
    };

    const disconnect = () => {
        const payload: IHubspotDisconnectDTO = {
            userGuid: userModel.guid,
            userToken: userModel.token,
            supplierGuid: supplierModel.guid,
        };

        props.socket.emit(EndpointsEnum.HubspotDisconnect, payload);
    };

    const onDisconnect = () => {
        const notification: INotification = {
            message: "successfully_disconnected_hubspot",
            level: NotificationLevelEnum.success,
            position: NotificationPositionEnum.bc,
        };

        props.notifyFn(null, notification);

        const payload: ILoadUserDTO = {
            userGuid: userModel.guid,
            userToken: userModel.token,
        };

        props.socket.emit(EndpointsEnum.AppLoadUser, payload);
    };

    return (
        <div className={"HubspotConnect"}>
            <OwAccordion
                hideChevron={!supplierModel.Supplier_Integration.has_hubspot}
                leftImage={hubSpotLogo}
                leftImageHeight={30}
                rightElem={
                    <div className={"ms-auto"}>
                        {/*<OwLabel title={"coming_soon"} />*/}
                        {supplierModel.Supplier_Integration.has_hubspot ? (
                            <OwBadge title={"connected"} leftIconClass={"fas fa-check"} bgColor={"bg-success"} />
                        ) : (
                            <OwButton title={"connect"} fn={startOauth} />
                        )}
                    </div>
                }>
                <div>
                    <OwButton title={"disconnect"} leftIconClass={"fas fa-unlink"} fn={disconnect} className={"btn-danger"} />
                </div>
            </OwAccordion>
        </div>
    );
};
